<template>
    <Page>
        <section class="support-banner container">
            <div class="support-banner__container container">
                <h1 class="sr-only">{{ $t("meta.support.title") }}</h1>
                <h2 class="support-banner__subheading text-subheading">{{ $t("support.handbook_subheading") }}</h2>
                <p class="support-banner__heading text-heading text-heading--lg">{{ $t("support.handbook_heading") }}</p>
                <form @submit.prevent="searchHandbook" class="support-banner__form">
                    <ProInput
                        v-model="handbookQuery"
                        :placeholder="$t('support.handbook_search_placeholder')"
                        :label="$t('a11y-labels.search.keywords')"
                        label-hidden
                    >
                        <template v-slot:after>
                            <ProButton
                                class="pro-input-button"
                                type="submit"
                                :title="$t('a11y-labels.search.enter')"
                                :aria-label="$t('a11y-labels.search.enter')"
                            >
                                <ProIcon icon="search" />
                            </ProButton>
                        </template>
                    </ProInput>
                </form>
                <ProButton :to="{ name: 'handbook-product-all', params: { product: 'procreate', pathMatch: 'introduction' } }" variant="primary"
                    >{{ $t("support.handbook_cta") }} <ProIcon icon="cta-right"
                /></ProButton>
            </div>
        </section>
        <section class="support-artwork">
            <div class="support-artwork__container">
                <CreditMedia
                    :src="$asset($t('support.handbook_image'))"
                    alt=""
                    width="2932"
                    height="1700"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/asuka111-geisha.jpg')"
                    artist="Asuka111"
                    artwork="Geisha"
                    :commission="true"
                    class="ipad-explosion"
                />
            </div>
        </section>
        <section class="support-handbook-tiles container">
            <LinkTile
                :subheading="$t('support.pocket_handbook_subheading')"
                :heading="$t('support.pocket_handbook_heading')"
                :to="{ name: 'handbook-product-all', params: { product: 'pocket', pathMatch: 'introduction' } }"
                :title="$t('support.pocket_handbook_subheading')"
                :style="{ backgroundImage: `url('${$asset($t('support.pocket_handbook_image'))}')`, backgroundColor: '#080808' }"
                :aria-label="$t('support.pocket_handbook_label')"
            >
                <CreditMedia
                    :credit-only="true"
                    :thumbnail="$asset('images/credit-thumbnails/pocket/goro-fujita-the-lantern-maker.jpg')"
                    artist="Goro Fujita"
                    artwork="The Lantern Maker"
                    :commission="true"
                />
            </LinkTile>

            <LinkTile
                :subheading="$t('support.faq_subheading')"
                :heading="$t('support.faq_heading')"
                :to="{ name: 'faq' }"
                :title="$t('support.faq_subheading')"
                :style="{ backgroundImage: `url('${$asset($t('support.faq_image'))}')`, backgroundColor: '#080808' }"
                :aria-label="$t('support.faq_label')"
            />
        </section>
        <section class="support-form-block container">
            <div class="support-form-block__content">
                <h2 class="support-form-block__subheading text-subheading">{{ $t("support.contact_subheading") }}</h2>
                <p class="support-form-block__heading text-heading text-heading--md">{{ $t("support.contact_heading") }}</p>
            </div>
            <SupportForm />
        </section>

        <ArtistCredits />
    </Page>
</template>

<script>
import { mapGetters } from "vuex";
import ProInput from "@/components/ProInput";
import SupportForm from "@/components/support/SupportForm";
import { metaTitles, metaDescriptions, metaImages, metaKeywords } from "~/utils/meta";
import LinkTile from "@/components/LinkTile";
import CreditMedia from "@/components/CreditMedia";
import ArtistCredits from "@/components/ArtistCredits";

export default {
    components: {
        ProInput,
        SupportForm,
        LinkTile,
        CreditMedia,
        ArtistCredits,
    },
    scrollToTop: false,

    data: () => ({
        faqQuery: "",
        handbookQuery: "",
    }),

    methods: {
        searchHandbook() {
            this.$router.push(
                this.localePath({
                    name: "handbook-product",
                    params: {
                        product: "procreate",
                    },
                    query: { q: this.handbookQuery },
                })
            );
        },
    },

    computed: {
        ...mapGetters({
            credits: "creditMedia/getMedia",
        }),
    },

    head() {
        return {
            title: this.$t("meta.support.title"),
            meta: [
                ...metaTitles(this.$t("meta.support.title")),
                ...metaDescriptions(this.$t("meta.support.description")),
                ...metaImages(this.$asset(this.$t("meta.support.image"))),
                ...metaKeywords(this.$t("meta.support.keywords")),
            ],
        };
    },
};
</script>
